export default "__VITE_ASSET__DUIfdOlc__"